if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');

        this._selectors = {
          relatedColors: '[js-related-colors]'
        }
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this._initRelatedColors();
        document.addEventListener('DOMContentLoaded', this._hideYotpo);

        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });

      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      _hideYotpo = () => {
        // Wait for Yotpo to be fully loaded
        if (typeof window.yotpo === 'undefined') {
          setTimeout(() => this._hideYotpo(), 500);
          return;
        }

        const starsWidget = this.querySelector('.shopify-app-block > .yotpo');
        const reviewsWidget = document.querySelector('.shopify-app-block > .yotpo-widget-instance');
        const starsThreshold = Number(this.getAttribute('data-stars-threshold'));
        const reviewsThreshold = Number(this.getAttribute('data-reviews-threshold'));
        const config = { attributes: true, childList: true, subtree: true };

        const callback = (mutationList, observer) => {
          for (const mutation of mutationList) {
            if (mutation.type === 'childList' && reviewsWidget || starsWidget) {
              const reviews = starsWidget.querySelector('span.yotpo-stars + *[aria-label]');
              const reviewCount = parseInt(reviews?.getAttribute('aria-label'), 10);
              const avgScore = Number(reviewsWidget.querySelector('.yotpo-bottom-line')?.getAttribute('average-score'));

              if (!reviews || reviewCount < reviewsThreshold || avgScore < starsThreshold) {
                starsWidget.style.display = 'none'
                reviewsWidget.style.display = 'none'
              } else {
                starsWidget.style.display = 'block'
                reviewsWidget.style.display = 'block'
              }
            }
          }
        }

        const observer = new MutationObserver(callback);
        observer.observe(reviewsWidget, config);
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      async _initRelatedColors() {
        this.relatedColorsContainer = this.querySelectorAll(this._selectors.relatedColors);

        if (this.relatedColorsContainer.length < 1) {
          return;
        }
    
        const currentProductHandle = this.relatedColorsContainer[0].getAttribute('data-handle');
        const relatedColorsTag = this.relatedColorsContainer[0].getAttribute('data-tag');
        const targetURL = `/collections/all-products/${relatedColorsTag}/?view=json`;
        const relatedColorsJSON = await this._getRelatedColorJSON(targetURL);
        let relatedColorsMarkup = '';
    
        if (relatedColorsJSON.length <= 1) {
          return;
        }

        relatedColorsJSON.forEach((product) => {
          if (product.handle == currentProductHandle) {
            relatedColorsMarkup = `${relatedColorsMarkup}<div class="product-related-colors__current" aria-current="true" aria-label="${product.color}"><div class="product-related-colors__swatch" src="${product.swatch}" alt="${product.color}" data-swatch="${product.swatch_color}"/></div></div>`
          }else{
            relatedColorsMarkup = `${relatedColorsMarkup}<a href="${product.url}" class="product-related-colors__related" aria-label="${product.color}"><div class="product-related-colors__swatch" src="${product.swatch}" alt="${product.color}" data-swatch="${product.swatch_color}" js-color-swatch-link></div></a>`
          }
        })
    
        this.relatedColorsContainer.forEach(container => {
          container.innerHTML = relatedColorsMarkup;
          container.classList.remove('hidden');
        })

        const swatchElements = document.querySelectorAll('.product-related-colors__swatch');
        swatchElements.forEach((swatchElement) => {
          const swatchColor = swatchElement.getAttribute('data-swatch');
          swatchElement.style.backgroundColor = swatchColor;
          }
        );

    
        this._handleColorHover()
      }
    
      _handleColorHover(){
        const currentColor = document.querySelector(".product-related-colors__current");
        const currentColorText = document.querySelector(".product__variant-color");
    
        this.relatedColorsContainer[0].addEventListener('mouseover', function(event) {
            const target = event.target.closest(".product-related-colors__related");
            if (target && target.classList.contains('product-related-colors__related')) {
                currentColorText.innerText = target.getAttribute('aria-label');
            }
        });
        
        this.relatedColorsContainer[0].addEventListener('mouseout', function(event) {
            const target = event.target;
            if (target.classList.contains('product-related-colors__related')) {
                currentColorText.innerText = currentColor.getAttribute('aria-label');
            }
        });
      }
    
      _getRelatedColorJSON(url) {
        return fetch(url)
          .then(response => response.text())
          .then((text) => {
            const html = text;
            const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
            const JSONcontainer = parsedHTML.querySelector('[js-collection-json]');
            const parsedJSON = JSON.parse(JSONcontainer.innerHTML);
            return parsedJSON;
          })
      }
    }
  );
}
